module.exports = __webpack_public_path__ + "img/type6.8e87df07.png";